// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"dea14c47","254":"d77c2b7c","376":"2a662250","390":"a142e70c","562":"e5321664","760":"3a9c83ff","808":"8f8a347c","823":"1a2c2342","956":"119081b8"}[chunkId] + ".chunk.css";
};